export default __webpack_public_path__ + "static/timegrid-events-good-ccbfdf60e507a3e7c41f12152afd253a.png";